// src/pages/RegisterPage.jsx
import React from "react";
import LoginForm from "./Components/LoginForm";

const LoginPage = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default LoginPage;
